import Home from './Home'
import Test from './Test'
import CredisHistory from './CredisHistory'
import Login from './Login'
import LinCheckContract from './LinCheckContract'
import LiffLogin from './LiffLogin'
import ExchangeToDiscount from './ExchangeToDiscount'
import MyPoints from './MyPoints'

export default {
  Home,
  Test,
  CredisHistory,
  Login,
  LinCheckContract,
  LiffLogin,
  ExchangeToDiscount,
  MyPoints
}



// WEBPACK FOOTER //
// ./src/components/Home/index.js